import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { apiProductBackendBaseUrl } from '@/lib/constants';
import { Axios } from '../axios';

export const useGetAllApiList = (token, params) => {
  return useQuery({
    queryKey: ['useGetAllApiList', params],
    queryFn: async () => {
      const result = await axios.get(
        `${apiProductBackendBaseUrl}/api?${params}`,
        {
          headers: {
            Authorization: token,
            'ngrok-skip-browser-warning': 1,
            'bypass-tunnel-reminder': 1,
          },
        },
      );
      return result.data;
    },
  });
};

export const useGetAPiTransaction = (queryParams = '') => {
  return useQuery({
    queryKey: ['apiTransaction', queryParams],
    queryFn: async () => {
      const result = await Axios.get(
        `${apiProductBackendBaseUrl}/apiTransactionLogs/logs?${queryParams}`,
      );
      return result;
    },
  });
};

export const rechargeWallet = (body) => {
  const response = Axios.post(`bca/wallet-recharge`, body);
  return response;
};

export const useFetchWalletBalance = () => {
  return useQuery({
    queryKey: ['getWalletBalance'],
    queryFn: async () => {
      const result = await Axios.get(
        `${apiProductBackendBaseUrl}/apiWallet/balance`,
      );
      return result.data;
    },
  });
};

export const exportApiTransactionLogs = (filters = '') => {
  const response = Axios.get(
    `${apiProductBackendBaseUrl}/apiTransactionLogs/logs/export${filters ? `?${filters}` : ''}`,
    {
      responseType: 'blob',
      headers: {
        Accept:
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      },
    },
  );
  return response;
};
